<div style="overflow-x: hidden;">
  <app-website-header></app-website-header>
  <app-carousel></app-carousel>
  <div class="page" style="background-color: rgba(69, 79, 89, 0.04); ">
    <div class="row mt-1 mb-1 breadcrumb-top">
      <div class="d-flex align-items-start mt-4 headersBreadcrumd" style="flex-wrap: nowrap !important;">
        <img src="assets/images/home.svg" alt="landingpage" class="products "
          style="margin: 2.5px 0px 0px 0px; cursor: pointer;" [routerLink]="['/']">
        <a class="breadcrummb ps-2"
          [routerLink]="['/']" >{{'Home / '}}</a><span class="breadcrummb ps-2">Products Search</span>
        <span class="products" style="margin-top: 1px; font-size: 15px;">
          <app-bread-crumb [breadcrumb]="breadcrumb"></app-bread-crumb>
        </span>
          <span *ngIf="!isMobileScreen" class="product-count">
            Products: {{ totalProductCount }}
          </span>
      </div>
    </div>
    <div class="category-display" style="margin-left: 25px; margin-right: 30px;">
      <div class="row d-flex category-details" style="justify-content: space-between;">
        <div class="col-md-3 col-12">
          <app-products-search-filter [filterColumns]="filterColumns" [data]="originalData"
             (filterFormFields)="onFilteredData($event)" [searchKeyword]="productDetailsDto.searchKeyword"></app-products-search-filter>
        </div>

        <div class="right category-subcategories-list col-md-{{ category?.subcategories?.length === 0 ? 9 : 12 }}">
          <div class="row catergory-main">
            <div class="heading-with-line">
              <div class="line1"></div>
              <div class="heading-text" style="font-weight: bolder;font-size:12; font-family: 'Georgia' !important; ">
                Products for "{{ productDetailsDto.searchKeyword }}"</div>
              <div class="line2"></div>
            </div>
            <div class="row categoriesProducts">
              <ng-container *ngFor="let product of products">
                <div class="categories col-12 col-sm-6 col-md-6 col-lg-3 mb-4">
                  <app-product-info-card [id]="product?.id" [productImage]="product?.productImage"
                    [title]="product?.title | titlecase" [subtitleImage]="product?.subtitleImage"
                    [contentItems]="product?.contentItems" [isCategoryCard]="false" [isViewAll]="this.isViewAll"
                    [hoverText]="product?.hoverText" [oemId]="product?.oemId"
                    [totalProductCount]="totalProductCount ? totalProductCount: 0"
                    (allProductsCount)="onAllProductsCount($event)">
                  </app-product-info-card>
                </div>
              </ng-container>
              <div *ngIf="showNoRecordsFounds" class="no-results">
                <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
                <div class="no-records-found"> No Products Found </div>
              </div>
              <div *ngIf="!showNoRecordsFounds" class="page-numbers mb-5 d-none d-md-flex justify-content-center">
                <button mat-icon-button (click)="prevpage()" [disabled]="pageNumber === 0 ">
                  <img src="assets/images/pagination_prev.svg" alt="" srcset="">
                </button>

                <ng-container *ngFor="let page of showAllPaginationNumbers()">
                  <button mat-button *ngIf="page !== '...'" [class.page-active]="pageNumber === page"
                    (click)="changePage(+page)">
                    {{ +page + 1 }}
                  </button>
                  <span *ngIf="page === '...'">...</span>
                </ng-container>

                <button mat-icon-button (click)="nextpage()"
                  [disabled]=" (this.zero && this.pageNumber >= this.pageNumberMXM || this.pageNumberMXM !== -1 && this.pageNumber > this.pageNumberMXM ) ">
                  <img src="assets/images/pagination_next.svg" alt="" srcset="">
                </button>
                <p class="end-text" style="color: #0D87C8;margin-left: 25px;">Total Entries: {{totalProductCount}}</p>

              </div>
              <div *ngIf="!showNoRecordsFounds"
                class="page-numbers mb-5 d-flex flex-column align-items-center d-md-none justify-content-center ">
                <div style="display: flex; align-items: center;">
                  <button mat-icon-button (click)="prevpage()" [disabled]="pageNumber === 0 ">
                    <img src="assets/images/pagination_prev.svg" alt="" srcset="">
                  </button>

                  <ng-container *ngFor="let page of showAllPaginationNumbers()">
                    <button mat-button *ngIf="page !== '...'" [class.page-active]="pageNumber === page"
                      (click)="changePage(+page)">
                      {{ +page + 1 }}
                    </button>
                    <span *ngIf="page === '...'">...</span>
                  </ng-container>

                  <button mat-icon-button (click)="nextpage()"
                    [disabled]="isPaginationDisabled">
                    <img src="assets/images/pagination_next.svg" alt="" srcset="">
                  </button>
                </div>
                <p class="end-text" style="color: #0D87C8;">Total Entries: {{totalProductCount}}</p>

              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <app-website-footer></app-website-footer>
</div>